import { render, staticRenderFns } from "./Qrcodesdel.vue?vue&type=template&id=4bd45806&scoped=true"
import script from "./Qrcodesdel.vue?vue&type=script&lang=js"
export * from "./Qrcodesdel.vue?vue&type=script&lang=js"
import style0 from "./Qrcodesdel.vue?vue&type=style&index=0&id=4bd45806&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd45806",
  null
  
)

export default component.exports